import { render, staticRenderFns } from "./RadioSkeleton.vue?vue&type=template&id=4dd0be42"
import script from "./RadioSkeleton.vue?vue&type=script&lang=js"
export * from "./RadioSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports